import { IsOptional } from "class-validator";

export class CreateArenaDto {
  readonly token: string;
  readonly owner: string;

  @IsOptional()
  readonly surface: number = 0;

  @IsOptional()
  readonly distance: number = 0;

  @IsOptional()
  readonly weather: number = 0;
}
